"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isEqual = void 0;

var _curry = require("../curry/curry");

var _isEqual = function _isEqual(a, b) {
  return Number.isNaN(a) && Number.isNaN(b) ? true : a === b;
};
/**
 * Check if a tripple-equals b (accounts for null, undefined and NaN)
 *
 * @param {Mixed} a First value
 * @param {Mixed} b Second value
 *
 * @return {Boolean}
 *
 * @tag Core
 * @signature (a: Mixed) => (b: Mixed): Boolean
 * @signature (a: Mixed, b: Mixed): Boolean
 *
 * @example
 * equal(2)(2)
 * // => true
 *
 * equal("2")(2)
 * // => false
 *
 * equal(NaN)(NaN)
 * // => true
 *
 * equal([1])([1])
 * // => false
 */


var isEqual = (0, _curry.curry)(_isEqual);
exports.isEqual = isEqual;